module.exports = __webpack_public_path__ + "static/media/viewIcon.663a3409.svg";